module.exports = __webpack_public_path__ + "assets/images/extra_lady2.eb6b5a2bc6436d6199e6d13661633506.svg";